import React from 'react';
import cx from 'classnames';
import { numFormat } from 'utils/numFormat';

import FormattedMessage from 'components/FormattedMessage/FormattedMessage';

import styles from './OfferPriceRow.css';

export default function PriceRow({
	textClassName = '',
	valueClassName = '',
	text,
	value,
	valueText = '',
	prefix = '',
	isDecimal = false,
	subText = null
}) {
	if (!text) {
		return null;
	}
	const getPriceValue = (value, isDecimal) => {
		return isDecimal ? Number(value).toFixed(2) : numFormat(Number(value));
	};

	let formattedValue;

	if (!isNaN(value)) {
		formattedValue = Number(value) <= 0 ? null : `${prefix} ₹ ${getPriceValue(value, isDecimal)}`;
	} else {
		formattedValue = (
			<React.Fragment>
				{prefix}
				<FormattedMessage data={value.data} imageSize={12} imageClass={styles['coin-icon']} />
			</React.Fragment>
		);
	}

	if (valueText) {
		formattedValue = <React.Fragment>{valueText}</React.Fragment>;
	}

	return (
		<div className={styles['offer-price-row']}>
			<div className={cx(styles['price-text'], textClassName)} data-aid="price-text">
				{text}
				{subText && <div className={styles['sub-text']}>{subText}</div>}
			</div>
			{formattedValue && (
				<div className={cx(styles['price-value'], valueClassName)} data-aid="price-value">
					{formattedValue}
				</div>
			)}
		</div>
	);
}
